// Centralized cache configuration for all API calls

export const CacheConfig = {
  // Static content that rarely changes
  STATIC: {
    revalidate: 86400, // 24 hours
  },

  // Blog posts and articles
  BLOG: {
    revalidate: 3600, // 1 hour
  },

  // Dynamic content that changes frequently
  DYNAMIC: {
    revalidate: 300, // 5 minutes
  },

  // Real-time content
  REALTIME: {
    cache: "no-store" as const,
  },

  // Portfolio and case studies
  PORTFOLIO: {
    revalidate: 7200, // 2 hours
  },

  // Testimonials
  TESTIMONIALS: {
    revalidate: 21600, // 6 hours
  },

  // Job listings
  JOBS: {
    revalidate: 1800, // 30 minutes
  },

  // Service pages
  SERVICES: {
    revalidate: 43200, // 12 hours
  },
} as const;

/**
 * Helper to create fetch options with caching
 */
export function createFetchOptions(
  cacheType: keyof typeof CacheConfig,
  additionalOptions?: RequestInit,
): RequestInit {
  const cacheConfig = CacheConfig[cacheType];

  return {
    ...additionalOptions,
    next:
      "revalidate" in cacheConfig
        ? { revalidate: cacheConfig.revalidate }
        : undefined,
    cache: "cache" in cacheConfig ? cacheConfig.cache : undefined,
  };
}
